/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentVariantResponse } from './AppointmentVariantResponse';
import {
    AppointmentVariantResponseFromJSON,
    AppointmentVariantResponseFromJSONTyped,
    AppointmentVariantResponseToJSON,
    AppointmentVariantResponseToJSONTyped,
} from './AppointmentVariantResponse';
import type { AppointmentLocationResponse } from './AppointmentLocationResponse';
import {
    AppointmentLocationResponseFromJSON,
    AppointmentLocationResponseFromJSONTyped,
    AppointmentLocationResponseToJSON,
    AppointmentLocationResponseToJSONTyped,
} from './AppointmentLocationResponse';
import type { GetAppointmentTypeResponse } from './GetAppointmentTypeResponse';
import {
    GetAppointmentTypeResponseFromJSON,
    GetAppointmentTypeResponseFromJSONTyped,
    GetAppointmentTypeResponseToJSON,
    GetAppointmentTypeResponseToJSONTyped,
} from './GetAppointmentTypeResponse';
import type { AppointmentClassRoomResponse } from './AppointmentClassRoomResponse';
import {
    AppointmentClassRoomResponseFromJSON,
    AppointmentClassRoomResponseFromJSONTyped,
    AppointmentClassRoomResponseToJSON,
    AppointmentClassRoomResponseToJSONTyped,
} from './AppointmentClassRoomResponse';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { PriceType } from './PriceType';
import {
    PriceTypeFromJSON,
    PriceTypeFromJSONTyped,
    PriceTypeToJSON,
    PriceTypeToJSONTyped,
} from './PriceType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';
import type { GetTeacherBaseResponse } from './GetTeacherBaseResponse';
import {
    GetTeacherBaseResponseFromJSON,
    GetTeacherBaseResponseFromJSONTyped,
    GetTeacherBaseResponseToJSON,
    GetTeacherBaseResponseToJSONTyped,
} from './GetTeacherBaseResponse';

/**
 * 
 * @export
 * @interface GetAppointmentResponse
 */
export interface GetAppointmentResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof GetAppointmentResponse
     */
    appointmentId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentResponse
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentResponse
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentResponse
     */
    onlineMeetingUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentResponse
     */
    duration: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetAppointmentResponse
     */
    payRate: number;
    /**
     * 
     * @type {number}
     * @memberof GetAppointmentResponse
     */
    price: number;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetAppointmentResponse
     */
    maxNumberOfStudents: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof GetAppointmentResponse
     */
    allowOnlineBooking: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAppointmentResponse
     */
    allowCancellation: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentResponse
     */
    bookingNotice: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentResponse
     */
    cancellationNotice: string | null;
    /**
     * 
     * @type {any}
     * @memberof GetAppointmentResponse
     */
    startDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetAppointmentResponse
     */
    endDate: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetAppointmentResponse
     */
    requirePayment: boolean;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetAppointmentResponse
     */
    slotIntervalMinutes: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {PriceType}
     * @memberof GetAppointmentResponse
     */
    priceType: PriceType;
    /**
     * 
     * @type {boolean}
     * @memberof GetAppointmentResponse
     */
    isApprovalRequired: boolean;
    /**
     * 
     * @type {GetAppointmentTypeResponse}
     * @memberof GetAppointmentResponse
     */
    appointmentType: GetAppointmentTypeResponse | null;
    /**
     * 
     * @type {GetTeacherBaseResponse}
     * @memberof GetAppointmentResponse
     */
    teacher: GetTeacherBaseResponse | null;
    /**
     * 
     * @type {Array<AppointmentClassRoomResponse>}
     * @memberof GetAppointmentResponse
     */
    classRooms: Array<AppointmentClassRoomResponse>;
    /**
     * 
     * @type {Array<AppointmentVariantResponse>}
     * @memberof GetAppointmentResponse
     */
    variants: Array<AppointmentVariantResponse>;
    /**
     * 
     * @type {Array<AppointmentLocationResponse>}
     * @memberof GetAppointmentResponse
     */
    locations: Array<AppointmentLocationResponse>;
}



/**
 * Check if a given object implements the GetAppointmentResponse interface.
 */
export function instanceOfGetAppointmentResponse(value: object): value is GetAppointmentResponse {
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('onlineMeetingUrl' in value) || value['onlineMeetingUrl'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('payRate' in value) || value['payRate'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('maxNumberOfStudents' in value) || value['maxNumberOfStudents'] === undefined) return false;
    if (!('allowOnlineBooking' in value) || value['allowOnlineBooking'] === undefined) return false;
    if (!('allowCancellation' in value) || value['allowCancellation'] === undefined) return false;
    if (!('bookingNotice' in value) || value['bookingNotice'] === undefined) return false;
    if (!('cancellationNotice' in value) || value['cancellationNotice'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('requirePayment' in value) || value['requirePayment'] === undefined) return false;
    if (!('slotIntervalMinutes' in value) || value['slotIntervalMinutes'] === undefined) return false;
    if (!('priceType' in value) || value['priceType'] === undefined) return false;
    if (!('isApprovalRequired' in value) || value['isApprovalRequired'] === undefined) return false;
    if (!('appointmentType' in value) || value['appointmentType'] === undefined) return false;
    if (!('teacher' in value) || value['teacher'] === undefined) return false;
    if (!('classRooms' in value) || value['classRooms'] === undefined) return false;
    if (!('variants' in value) || value['variants'] === undefined) return false;
    if (!('locations' in value) || value['locations'] === undefined) return false;
    return true;
}

export function GetAppointmentResponseFromJSON(json: any): GetAppointmentResponse {
    return GetAppointmentResponseFromJSONTyped(json, false);
}

export function GetAppointmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAppointmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['appointmentId']),
        'name': json['name'],
        'description': json['description'],
        'onlineMeetingUrl': json['onlineMeetingUrl'],
        'duration': json['duration'],
        'payRate': json['payRate'],
        'price': json['price'],
        'maxNumberOfStudents': ApiUserTasksGetPageParameterFromJSON(json['maxNumberOfStudents']),
        'allowOnlineBooking': json['allowOnlineBooking'],
        'allowCancellation': json['allowCancellation'],
        'bookingNotice': json['bookingNotice'],
        'cancellationNotice': json['cancellationNotice'],
        'startDate': json['startDate'],
        'endDate': json['endDate'],
        'requirePayment': json['requirePayment'],
        'slotIntervalMinutes': ApiUserTasksGetPageParameterFromJSON(json['slotIntervalMinutes']),
        'priceType': PriceTypeFromJSON(json['priceType']),
        'isApprovalRequired': json['isApprovalRequired'],
        'appointmentType': GetAppointmentTypeResponseFromJSON(json['appointmentType']),
        'teacher': GetTeacherBaseResponseFromJSON(json['teacher']),
        'classRooms': ((json['classRooms'] as Array<any>).map(AppointmentClassRoomResponseFromJSON)),
        'variants': ((json['variants'] as Array<any>).map(AppointmentVariantResponseFromJSON)),
        'locations': ((json['locations'] as Array<any>).map(AppointmentLocationResponseFromJSON)),
    };
}

export function GetAppointmentResponseToJSON(json: any): GetAppointmentResponse {
    return GetAppointmentResponseToJSONTyped(json, false);
}

export function GetAppointmentResponseToJSONTyped(value?: GetAppointmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['appointmentId']),
        'name': value['name'],
        'description': value['description'],
        'onlineMeetingUrl': value['onlineMeetingUrl'],
        'duration': value['duration'],
        'payRate': value['payRate'],
        'price': value['price'],
        'maxNumberOfStudents': ApiUserTasksGetPageParameterToJSON(value['maxNumberOfStudents']),
        'allowOnlineBooking': value['allowOnlineBooking'],
        'allowCancellation': value['allowCancellation'],
        'bookingNotice': value['bookingNotice'],
        'cancellationNotice': value['cancellationNotice'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'requirePayment': value['requirePayment'],
        'slotIntervalMinutes': ApiUserTasksGetPageParameterToJSON(value['slotIntervalMinutes']),
        'priceType': PriceTypeToJSON(value['priceType']),
        'isApprovalRequired': value['isApprovalRequired'],
        'appointmentType': GetAppointmentTypeResponseToJSON(value['appointmentType']),
        'teacher': GetTeacherBaseResponseToJSON(value['teacher']),
        'classRooms': ((value['classRooms'] as Array<any>).map(AppointmentClassRoomResponseToJSON)),
        'variants': ((value['variants'] as Array<any>).map(AppointmentVariantResponseToJSON)),
        'locations': ((value['locations'] as Array<any>).map(AppointmentLocationResponseToJSON)),
    };
}

